<template>
  <component v-if="isComponent" :is="label" v-bind="props" />
  <template v-else>{{ label }}</template>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: [String, Object],
    required: true,
  },
});

const isComponent = computed(() => {
  return typeof props.label === "object";
});
</script>
